import React from 'react';
import './Spinner.scss';

const Spinner = () => (
    <div className={'Loader'}>Loading...</div>
);

export default Spinner;
